import React from 'react'

const cssTitle = {
  fontSize: '28px',
  fontWeight: 'bold',
  borderWidth: '2px 2px 2px 2px',
  borderStyle: 'solid',
  borderRadius: '30px 30px 30px 30px',
  margin: '0.5em 4%',
  textAlign: 'center',
  padding: '0.5em 15px'
}

export default function Title ({ text }) {
  return (
    <div style={cssTitle}>
      {text}
    </div>
  )
}
